import { OwcChip } from "@one/react";

const CustomChip = ({ text, color, bgColor, bold, onClick=() => {}, compact=false, info }) => {
  const styleBase = {
    color: color,
    backgroundColor: bgColor,
    fontWeight: (bold ? "bold" : "normal"),
  };
  const compactStyles = compact ? {
    height: '1.25rem',
    minHeight: '1.25rem',
    lineHeight: '1.25rem',
    fontSize: '0.75rem',
    padding: '0 0.5rem'
  } : {};
  return (
    <OwcChip
      round
      style={{ ...styleBase, ...compactStyles }}
      title={info}
      aria-label={info}
      onClick={onClick}
    >
      {text}
    </OwcChip>
  );
};
export default CustomChip;
